import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { images } from './data/bonuses';
import { initMetaPixel } from './utils/metaPixel';
const FONT_CSS = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Poppins:wght@400;500;600;700&display=swap';
function head(tag: string, attrs: Record<string, string>) {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
  return el;
}
function setMeta(name: string, content: string) {
  const existing = document.querySelector(`meta[name="${name}"]`);
  if (existing) {
    existing.setAttribute('content', content);
    return;
  }
  head('meta', {
    name,
    content
  });
}

/** Head is built in priority order: meta -> connections -> preloads -> async fonts. */
function buildHead() {
  setMeta('viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
  setMeta('theme-color', '#FFF9EF');
  setMeta('description', 'El Gran Reto Creativo: 365 ideas listas para jugar, crear y divertirse en casa. Incluye 10 bonos gratis y el Pasaporte Creativo.');
  document.title = 'El Gran Reto Creativo · 365 ideas para crear juntos';

  // Early connections
  head('link', {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  });
  head('link', {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossorigin: 'anonymous'
  });
  head('link', {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com'
  });
  head('link', {
    rel: 'dns-prefetch',
    href: 'https://cdn.shopify.com'
  });
  head('link', {
    rel: 'dns-prefetch',
    href: 'https://elgranretocreativo.shop'
  });
  head('link', {
    rel: 'dns-prefetch',
    href: 'https://checkout.shopify.com'
  });
  head('link', {
    rel: 'dns-prefetch',
    href: 'https://js.stripe.com'
  });
  head('link', {
    rel: 'dns-prefetch',
    href: 'https://www.paypal.com'
  });

  // Hero image gets the highest fetch priority (LCP candidate)
  head('link', {
    rel: 'preload',
    as: 'image',
    href: images.mainBook,
    fetchpriority: 'high'
  });

  // Fonts: preload the stylesheet, then attach it without blocking render
  head('link', {
    rel: 'preload',
    as: 'style',
    href: FONT_CSS,
    crossorigin: 'anonymous'
  });
  const fonts = head('link', {
    rel: 'stylesheet',
    href: FONT_CSS,
    media: 'print',
    crossorigin: 'anonymous'
  }) as HTMLLinkElement;
  fonts.onload = () => {
    fonts.media = 'all';
    fonts.onload = null;
  };
}
buildHead();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-279" data-mp="38vnmy2a4sq92" />);
}

/**
 * Meta Pixel: deferred until the browser is idle (200 ms fallback) so the
 * third-party script never competes with the first render on mobile.
 */
type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: {
    timeout?: number;
  }) => number;
};
const w = window as IdleWindow;
if (typeof w.requestIdleCallback === 'function') {
  w.requestIdleCallback(() => initMetaPixel(), {
    timeout: 1000
  });
} else {
  window.setTimeout(initMetaPixel, 200);
}